import {
  EmailTemplate as SharedEmailTemplate,
  EmailTemplateKey as SharedEmailTemplateKey,
  EMAIL_TEMPLATE_KEYS as SharedEmailTemplateKeys,
} from "shared/dist/types/EmailTemplate";

export type EmailTemplateKey = SharedEmailTemplateKey;
export const EMAIL_TEMPLATE_KEYS = SharedEmailTemplateKeys;

export default interface EmailTemplate extends SharedEmailTemplate {}
